module.exports = __webpack_public_path__ + "a18ffcdb156aad0baa8f62f4e9ef6b16.MP3";